<template>
    <div>
        <div class="alert alert-warning p-3">
            <span><slot name="info"></slot></span>
            <div class="d-flex justify-content-end w-100">
                <button
                    class="btn btn-link font-italic py-0"
                    @click="viewData()"
                    id="draft-details"
                >
                    <slot name="action"></slot>
                </button>
            </div>
        </div>

        <modal-component :id="`view-draft-${random}`" :visible="isVisible" @close="closeModal()">
            <div class="p-3" v-if="draft">
                <div class="d-flex justify-content-between align-items-center">
                    <i class="fa fa-2x fa-exclamation-triangle text-warning mr-5"></i>
                    <h5 class="">Some data could not be saved due to a connectivity issue</h5>
                </div>
                <div class="mt-3">
                    <p>
                        <span class="font-weight-bold">Attempted to save at: </span>
                        {{
                            draft.stored_at
                                ? moment(draft.stored_at, "YYYY-MM-DD HH:mm").format(
                                      "MM/DD/YY h:mm A"
                                  )
                                : "N/A"
                        }}
                    </p>

                    <p class="font-weight-bold">Data preview:</p>

                    <pre class="view-data">{{ JSON.stringify(draft.data, null, 2) }}</pre>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link text-danger px-0" @click="eraseData()">
                        Permanently erase the data
                    </button>
                    <button class="btn btn-primary text-uppercase" @click="retrySave()">
                        Retry saving
                    </button>
                </div>
            </div>
        </modal-component>
    </div>
</template>

<script>
import ModalComponent from "./ModalComponent";
export default {
    name: "LocalDataWidget",
    components: { ModalComponent },
    props: ["data", "draft"],
    data() {
        return {
            random: parseInt(Math.random() * 1e6),
            isVisible: false,
        };
    },
    methods: {
        viewData() {
            this.isVisible = true;
        },
        closeModal() {
            this.isVisible = false;
        },
        eraseData() {
            this.isVisible = false;
            this.$emit("erase-draft");
        },
        retrySave() {
            this.isVisible = false;
            this.$emit("retry-save");
        },
    },
};
</script>

<style scoped>
.view-data {
    max-height: 50vh;
    overflow-y: auto;
}
</style>
